// Sektör (yönetim sektörü) yardımcıları — Login, Layout ve Sektör Ayarları paylaşır.
import {
  Store, ShoppingBag, Globe, Warehouse, Truck, Hotel, Coffee, Factory, Wrench,
  Sprout, UtensilsCrossed, Megaphone, Gamepad2, Building2, Boxes, Landmark,
  Package, Cog, Briefcase, Leaf,
  Pill, Shirt, Footprints, Gem, Glasses, BookOpen, Hammer, Sofa, Tv, Car, Fuel,
  Beef, Apple, Croissant, Droplet, Scissors, Dumbbell, Stethoscope, PawPrint,
  Home, GraduationCap, Plane, HardHat, Ship, Star,
} from "lucide-react";

// Backend ile birebir aynı olmalı (SECTOR_GATED_ROUTES). Bu kümedeki rotalar sektöre göre filtrelenir;
// dışındakiler (Panel, Mesajlar, AI ve tüm Yönetim menüsü) her sektörde görünür.
export const SECTOR_GATED_ROUTES = [
  "/urunler", "/katalog-sagligi", "/fiyat-yonetimi", "/halk-gunu", "/kategoriler",
  "/stok", "/sayim", "/fire", "/lojistik",
  "/satin-alma", "/transferler", "/mal-kabul", "/tedarikciler",
  "/kasa", "/satislar", "/vardiyalar", "/musteriler",
  "/muhasebe", "/e-belge", "/raporlar", "/onaylar", "/puan-odul", "/anketler",
  "/toptan-denetim", "/firsatlar",
];

// Sektör Ayarları çoklu-seçim listesi (etiket + grup).
export const SECTOR_MODULE_CATALOG = [
  { group: "Katalog & Fiyat", items: [
    { key: "/urunler", label: "Ürün Kartları" },
    { key: "/katalog-sagligi", label: "Katalog Sağlığı" },
    { key: "/fiyat-yonetimi", label: "Fiyat Yönetimi" },
    { key: "/halk-gunu", label: "Halk Günü / Geçici İndirim" },
    { key: "/kategoriler", label: "Kategoriler" },
  ] },
  { group: "Stok & Lojistik", items: [
    { key: "/stok", label: "Stok" },
    { key: "/sayim", label: "Depo Sayımı" },
    { key: "/fire", label: "Fire / Zayiat" },
    { key: "/lojistik", label: "Lojistik / Sevkiyat" },
  ] },
  { group: "Satın Alma & Tedarik", items: [
    { key: "/satin-alma", label: "Satın Alma" },
    { key: "/transferler", label: "Transferler & Siparişler" },
    { key: "/mal-kabul", label: "Mal Kabul" },
    { key: "/tedarikciler", label: "Tedarikçiler" },
  ] },
  { group: "Satış & Müşteri", items: [
    { key: "/kasa", label: "Kasa / Hızlı Satış" },
    { key: "/satislar", label: "Satışlar" },
    { key: "/vardiyalar", label: "Vardiyalar (Z Rapor)" },
    { key: "/musteriler", label: "Müşteriler" },
  ] },
  { group: "Muhasebe", items: [
    { key: "/muhasebe", label: "Muhasebe Paneli" },
    { key: "/e-belge", label: "E-Belge" },
  ] },
  { group: "Analiz & Onay", items: [
    { key: "/raporlar", label: "Raporlar" },
    { key: "/onaylar", label: "Onaylar" },
    { key: "/puan-odul", label: "Puan & Ödül" },
    { key: "/anketler", label: "Anketler & Öneriler" },
    { key: "/toptan-denetim", label: "Toptan Yetki Denetimi" },
  ] },
  { group: "Araçlar", items: [
    { key: "/firsatlar", label: "Pazar Araştırması" },
  ] },
];

const SECTOR_ICONS = {
  Store, ShoppingBag, Globe, Warehouse, Truck, Hotel, Coffee, Factory, Wrench,
  Sprout, UtensilsCrossed, Megaphone, Gamepad2, Building2, Boxes, Landmark,
  Package, Cog, Briefcase, Leaf,
  Pill, Shirt, Footprints, Gem, Glasses, BookOpen, Hammer, Sofa, Tv, Car, Fuel,
  Beef, Apple, Croissant, Droplet, Scissors, Dumbbell, Stethoscope, PawPrint,
  Home, GraduationCap, Plane, HardHat, Ship, Star,
};

// Sektör grupları (backend SECTOR_GROUP_ORDER ile aynı sıra).
export const SECTOR_GROUP_ORDER = ["⭐ Özel", "Perakende & Market", "Gıda & Yeme-İçme", "Toptan & Lojistik",
  "Üretim & Teknik", "Sağlık & Bakım", "Hizmet & Kurumsal", "Diğer"];

// Her grubun başında gösterilecek temsili (genel) ikon.
export const SECTOR_GROUP_ICONS = {
  "⭐ Özel": Star, "Perakende & Market": Store, "Gıda & Yeme-İçme": UtensilsCrossed,
  "Toptan & Lojistik": Truck, "Üretim & Teknik": Factory, "Sağlık & Bakım": Stethoscope,
  "Hizmet & Kurumsal": Briefcase, "Diğer": Boxes,
};
export function sectorGroupIcon(group) { return SECTOR_GROUP_ICONS[group] || Boxes; }

// Sektör listesini gruplarına ayırır → [{ group, items }] (SECTOR_GROUP_ORDER sırasında).
export function groupSectors(list) {
  const by = {};
  (list || []).forEach((s) => { const g = s.group || "Diğer"; (by[g] = by[g] || []).push(s); });
  const ordered = [];
  SECTOR_GROUP_ORDER.forEach((g) => { if (by[g]) { ordered.push({ group: g, items: by[g] }); delete by[g]; } });
  Object.keys(by).forEach((g) => ordered.push({ group: g, items: by[g] }));
  return ordered;
}

// Sektör Ayarları'nda ikon seçimi için kullanılabilir liste.
export const SECTOR_ICON_NAMES = Object.keys(SECTOR_ICONS);

export function sectorIcon(name) {
  return SECTOR_ICONS[name] || Building2;
}
